import React, { useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../shared/CustomButton';
import { FaSave } from 'react-icons/fa';

const ShiftForm = ({
    shift,
    isSaving,
    formAction
}) => {
    const {
        register,
        reset,
        formState: {errors},
        setError,
        handleSubmit,
        getValues
    } = useForm({defaultValues : shift ? {
        id: shift.id,
        name: shift.name,
        start_at: shift.start_at,
        end_at: shift.end_at
        } : {}
    });

    const resetForm = () => {
        reset({
            id: '',
            name: '',
            start_at: '',
            end_at: ''
        });
    }

    useEffect(() => {
        if (shift){
            reset({
                id: shift.id,
                name: shift.name,
                start_at: shift.start_at,
                end_at: shift.end_at
            });
        } else {
            reset({
                id: '',
                name: '',
                start_at: '',
                end_at: ''
            });
        }
    }, [shift, reset]);

    const onSubmit = async (data) => {
        try {
            const success = await formAction(data);
            if (success){
                resetForm();
            }
        } catch (error){
            if (error.response && error.response.status === 422){
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error will be handled by saveShift() in Shifts.jsx
            }
        }
    }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='name'>Name</Form.Label>
                    <input type='text' autoFocus autoComplete='off' placeholder='Name'
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        {...register('name', {
                            required: 'Enter the shift\'s name'
                        })}
                    />
                    {errors.name && (
                        <div className="invalid-feedback">{errors.name.message}</div>
                    )}

                </Form.Group>
            
            </Col>

            <Col xl={3} lg={4} md={6} sm={12}>
                    
                <Form.Group>

                    <Form.Label htmlFor='start_at'>Start Time</Form.Label>
                    <input type='time' autoComplete='off' placeholder='Start Time'
                        className={`form-control ${errors.start_at ? 'is-invalid' : ''}`}
                        {...register('start_at', {
                            required: 'Enter the shift\'s start time'
                        })}
                    />
                    {errors.start_at && (
                        <div className="invalid-feedback">{errors.start_at.message}</div>
                    )}

                </Form.Group>
            
            </Col>

            <Col xl={3} lg={4} md={6} sm={12}>
                
                <Form.Group>

                    <Form.Label htmlFor='end_at'>End Time</Form.Label>
                    <input type='time' autoComplete='off' placeholder='End Time'
                        className={`form-control ${errors.end_at ? 'is-invalid' : ''}`}
                        {...register('end_at', {
                            required: 'Enter the shift\'s end time',
                            validate: (value) => {
                                const startAt = getValues('start_at');
            
                                // If start and end are the same, it's invalid
                                if (value === startAt) {
                                    return 'End time cannot be the same as start time';
                                }

                                // Logic: If end_at < start_at, the system implies the NEXT day.
                                // We return true to allow overnight shifts.
                                return true;
                            },
                        })}
                    />
                    {errors.end_at && (
                        <div className="invalid-feedback">{errors.end_at.message}</div>
                    )}

                </Form.Group>

            </Col>

        </Row>

        <CustomButton
            icon={<FaSave />}
            title={isSaving ? 'Saving' : 'Save'}
            isSaving={isSaving}
        />

    </Form>
  )
}

export default ShiftForm
